import { useContext } from "react";
import tools from "../../../../../helpers/tools";
import AssignationLead from "../../../../common/CarteLead/AssignationLead";
import EnTeteCarte from "../../../../common/CarteLead/EnTeteCarte";
import MenuActionsLead from "../../../../common/CarteLead/MenuActionsLead";
import { Creee, FORMAT_COURT, Modifiee, MotifAbandon } from "../../../../common/CarteLead/MetaCarte";
import ProduitLead from "../../../../common/CarteLead/ProduitLead";
import Puce from "../../../../common/CarteLead/Puce";
import StatutLead from "../../../../common/CarteLead/StatutLead";
import { LeadAutoItemContext } from "../LeadAutoItemContext";
import useLeadAutoItem from "../useLeadAutoItem";
import { progressionDemande } from "./progressionDemande";

export const PRODUIT_AUTO = { icone: "fa-car", libelle: "Assurance auto" };

export const nomDuLead = (lead = {}) => {
  const user = lead.user || {};
  return tools.getFullName({ gender: user.civilite, firstname: user.prenom, lastname: user.nom });
};

// En-tête de la carte lead auto : produit, nom (lien vers la recherche client),
// avancement de la demande, source, dates du parcours, motif d'abandon, puis
// les actions de traitement (statut, assignation, exports).
const EnTeteLead = () => {
  const { leadAutoItem, actions } = useLeadAutoItem();
  const { managers } = useContext(LeadAutoItemContext);
  const user = leadAutoItem.user || {};
  const productData = leadAutoItem.productdata || {};
  const progression = progressionDemande(leadAutoItem);

  const exports = [
    { id: "json", icone: "fa-download", libelle: "Exporter en JSON", aide: "informations du lead", onClick: actions.handleExportJSON },
    { id: "txt", icone: "fa-download", libelle: "Exporter en TXT", aide: "questions et réponses", onClick: actions.handleExportText },
  ];

  return (
    <EnTeteCarte
      produit={<ProduitLead {...PRODUIT_AUTO} />}
      idNom={`la-nom-${leadAutoItem.id}`}
      nom={nomDuLead(leadAutoItem)}
      lien={
        user.email
          ? { to: `/client-list?email=${encodeURIComponent(user.email)}`, titre: "Rechercher ce client dans un nouvel onglet" }
          : null
      }
      puces={
        <>
          <Puce ton={progression.ton} icone={progression.icone} titre={progression.description}>
            {progression.libelle}
          </Puce>
          {productData.source_lead && (
            <span className="la-puce la-puce--contour text-capitalize" title="Source d'acquisition du lead">
              {productData.source_lead}
            </span>
          )}
        </>
      }
      meta={
        <>
          <Creee iso={leadAutoItem.createdAt} />
          {(leadAutoItem.estimatedAt || leadAutoItem.finalizedAt) && (
            <span className="la-carte__parcours">
              {leadAutoItem.estimatedAt && (
                <span title="Première étape du formulaire terminée">
                  Étape 1 le <b>{tools.formatDate(leadAutoItem.estimatedAt, FORMAT_COURT)}</b>
                </span>
              )}
              {leadAutoItem.estimatedAt && leadAutoItem.finalizedAt && <i className="fa fa-arrow-right" aria-hidden="true" />}
              {leadAutoItem.finalizedAt && (
                <span title="Seconde étape du formulaire terminée : dossier complet">
                  Finalisée le <b>{tools.formatDate(leadAutoItem.finalizedAt, FORMAT_COURT)}</b>
                </span>
              )}
            </span>
          )}
          <Modifiee iso={leadAutoItem.updatedAt} />
        </>
      }
      motif={<MotifAbandon lead={leadAutoItem} />}
      actions={
        <>
          <StatutLead lead={leadAutoItem} onUpdateStatus={actions.onUpdateStatus} />
          <AssignationLead
            leadId={leadAutoItem.id}
            assignedTo={leadAutoItem.assignedTo}
            managers={managers}
            onAssigner={actions.onUpdateAssignTo}
          />
          <MenuActionsLead actions={exports} />
        </>
      }
    />
  );
};

export default EnTeteLead;
